// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-topbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  min-height: 5.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
}

.app-topbar .topbar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.app-topbar .logo-container {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-topbar .logo-container i {
  font-size: 1.8rem;
  color: #ffffff;
}

.app-topbar .logo-text {
  font-size: 1.65rem;
  font-weight: 600;
  color: var(--topbar-text);
}

.app-topbar .topbar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.app-topbar .user-info {
  text-align: right;
  line-height: 1.4;
}

.app-topbar .welcome-text {
  font-size: 0.9rem;
  color: #6c757d;
  display: block;
}

.app-topbar .user-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: #2c3e50;
}

.app-topbar .user-avatar {
  background: var(--accent-color);
  color: #ffffff;
  cursor: default;
  box-shadow: 0 2px 6px rgba(74, 144, 226, 0.2);
  width: 46px;
  height: 46px;
  font-size: 1.1rem;
}

.app-topbar .user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.app-topbar .menu-toggle {
  color: #6c757d;
}

.app-topbar .menu-toggle:hover {
  color: var(--accent-color);
}

/* Estilos del menú desplegable */
.app-topbar .p-menu {
  margin-top: 0.5rem;
}

.app-topbar .p-menu .p-menuitem-link {
  padding: 0.75rem 1rem;
  transition: all 0.2s ease;
}

.app-topbar .p-menu .p-menuitem-link:hover {
  background: #f8f9fa;
}

.app-topbar .p-menu .p-menuitem-icon {
  color: var(--accent-color);
  margin-right: 0.5rem;
}

/* Responsive */
@media (max-width: 768px) {
  .app-topbar {
    padding: 0 1rem;
  }

  .app-topbar .logo-container {
    width: 40px;
    height: 40px;
  }

  .app-topbar .logo-container i {
    font-size: 1.2rem;
  }

  .app-topbar .logo-text {
    font-size: 1.2rem;
  }

  .app-topbar .user-info {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/AppTopbar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".app-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  min-height: 5.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 2rem;\n}\n\n.app-topbar .topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.app-topbar .logo-container {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.app-topbar .logo-container i {\n  font-size: 1.8rem;\n  color: #ffffff;\n}\n\n.app-topbar .logo-text {\n  font-size: 1.65rem;\n  font-weight: 600;\n  color: var(--topbar-text);\n}\n\n.app-topbar .topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.app-topbar .user-info {\n  text-align: right;\n  line-height: 1.4;\n}\n\n.app-topbar .welcome-text {\n  font-size: 0.9rem;\n  color: #6c757d;\n  display: block;\n}\n\n.app-topbar .user-name {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.app-topbar .user-avatar {\n  background: var(--accent-color);\n  color: #ffffff;\n  cursor: default;\n  box-shadow: 0 2px 6px rgba(74, 144, 226, 0.2);\n  width: 46px;\n  height: 46px;\n  font-size: 1.1rem;\n}\n\n.app-topbar .user-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.app-topbar .menu-toggle {\n  color: #6c757d;\n}\n\n.app-topbar .menu-toggle:hover {\n  color: var(--accent-color);\n}\n\n/* Estilos del menú desplegable */\n.app-topbar .p-menu {\n  margin-top: 0.5rem;\n}\n\n.app-topbar .p-menu .p-menuitem-link {\n  padding: 0.75rem 1rem;\n  transition: all 0.2s ease;\n}\n\n.app-topbar .p-menu .p-menuitem-link:hover {\n  background: #f8f9fa;\n}\n\n.app-topbar .p-menu .p-menuitem-icon {\n  color: var(--accent-color);\n  margin-right: 0.5rem;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .app-topbar {\n    padding: 0 1rem;\n  }\n\n  .app-topbar .logo-container {\n    width: 40px;\n    height: 40px;\n  }\n\n  .app-topbar .logo-container i {\n    font-size: 1.2rem;\n  }\n\n  .app-topbar .logo-text {\n    font-size: 1.2rem;\n  }\n\n  .app-topbar .user-info {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
